import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert } from '../../../shared/components/Alert';
import { EmptyState } from '../../../shared/components/EmptyState';
import { PageContainer } from '../../../shared/components/PageContainer';
import { Skeleton } from '../../../shared/components/Skeleton';
import { PurchaseStatusBadge } from '../components/PurchaseBadges';
import { formatMoney } from '../components/format';
import { useApprovalQueue } from '../hooks';

export default function AprovacoesComprasPage() {
  const navigate = useNavigate();
  const queue = useApprovalQueue();
  const rows = queue.data?.data ?? [];
  return (
    <PageContainer title="Aprovações de compras" subtitle="Fila pessoal de decisões pendentes" breadcrumbs={[{ label: 'Compras', to: '/compras' }, { label: 'Aprovações' }]}>
      {queue.isError && <Alert variant="error">Não foi possível carregar a fila de aprovações.</Alert>}
      {queue.isLoading ? <Skeleton className="h-32 w-full" /> : rows.length === 0 ? (
        <EmptyState title="Nenhuma aprovação pendente" description="As solicitações que exigirem sua decisão aparecerão aqui." />
      ) : (
        <div className="overflow-x-auto rounded-lg border border-gray-200">
          <table className="min-w-full divide-y divide-gray-200 text-sm">
            <thead className="bg-gray-50 text-xs uppercase text-gray-500"><tr><th className="px-3 py-2 text-left">Número</th><th className="px-3 py-2 text-left">Solicitação</th><th className="px-3 py-2 text-left">Etapa</th><th className="px-3 py-2 text-left">Área</th><th className="px-3 py-2 text-right">Valor</th><th className="px-3 py-2 text-left">Status</th></tr></thead>
            <tbody className="divide-y divide-gray-100 bg-white">{rows.map(({ request, currentApproval }) => <tr key={currentApproval.id} className="cursor-pointer hover:bg-gray-50" onClick={() => navigate(`/compras/solicitacoes/${request.id}`)}><td className="px-3 py-3 font-medium">{request.requestNumber ?? request.code ?? 'Em geração'}</td><td className="px-3 py-3">{request.title}</td><td className="px-3 py-3">{currentApproval.stepLabel ?? currentApproval.stepKey}</td><td className="px-3 py-3">{request.requestingArea}</td><td className="px-3 py-3 text-right">{formatMoney(request.estimatedValue)}</td><td className="px-3 py-3"><PurchaseStatusBadge status={request.status} /></td></tr>)}</tbody>
          </table>
        </div>
      )}
    </PageContainer>
  );
}
